import React from "react";
import { ThemeMode } from "@foris/avocado-suite";
import styles from "./tourTooltipBeacon.module.scss";

interface TourTooltipBeaconProps {
  mode?: ThemeMode;
}

const TourTooltipBeacon: React.FC<TourTooltipBeaconProps> = () => {
  return (
    <div className={styles.tourTooltipBeacon}>
      <svg
        className={styles.tourTooltipBeacon_icon}
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
      >
        <g clipPath="url(#clip0_7852_13027)">
          <circle className={styles.tourTooltipBeacon_largeCircle} cx="8" cy="8" r="8" />
          <circle className={styles.tourTooltipBeacon_middleCircle} cx="8" cy="8" r="5" />
          <circle className={styles.tourTooltipBeacon_mainCircle} cx="8" cy="8" r="3" />
        </g>
        <defs>
          <clipPath id="clip0_7852_13027">
            <rect width="16" height="16" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </div>
  );
};

export default TourTooltipBeacon;
